import React__default from 'react';

const InfoIcon = () => {
    return (React__default.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: '16', height: '16', viewBox: '0 0 16 16', fill: 'none' },
        React__default.createElement("circle", { cx: '8', cy: '8', r: '7', stroke: 'currentColor', strokeWidth: '1.5' }),
        React__default.createElement("path", { d: 'M8 5.84615C8.14281 5.84615 8.27977 5.78942 8.38075 5.68844C8.48173 5.58746 8.53846 5.4505 8.53846 5.30769C8.53846 5.16488 8.48173 5.02792 8.38075 4.92694C8.27977 4.82596 8.14281 4.76923 8 4.76923C7.85719 4.76923 7.72023 4.82596 7.61925 4.92694C7.51827 5.02792 7.46154 5.16488 7.46154 5.30769C7.46154 5.4505 7.51827 5.58746 7.61925 5.68844C7.72023 5.78942 7.85719 5.84615 8 5.84615Z', fill: 'currentColor' }),
        React__default.createElement("path", { d: 'M8 7.5V11.5', stroke: 'currentColor', strokeWidth: '1.5', strokeLinecap: 'round' })));
};

export { InfoIcon };
//# sourceMappingURL=InfoIcon.js.map
